module.exports = __webpack_public_path__ + "img/Universal_Merchant_Bank.a5c48b30.jpg";